// Constants for provider promos (service_providers_promos table)
export const STATUS_ACTIVE = 'active'
export const STATUS_INACTIVE = 'inactive'
export const STATUS_PENDING = 'pending'

export const PROMO_SOURCE_CAMPAIGN = 'campaign'
export const PROMO_SOURCE_OFFICE = 'office'

// Types for better type safety
export type PromoStatus = typeof STATUS_ACTIVE | typeof STATUS_INACTIVE | typeof STATUS_PENDING
export type PromoSource = typeof PROMO_SOURCE_CAMPAIGN | typeof PROMO_SOURCE_OFFICE

// Promo type can be any string (not restricted to basicpromo anymore)
export type PromoType = string

export interface ProviderPromo {
    service_provider_promo_id: number
    service_provider_id: number
    promo_id: number | null
    user_id: number | null
    type: PromoType | null
    source: PromoSource | null
    extra_info: string | null
    status: PromoStatus
    start_date: string | null
    end_date: string | null
    created: string
    offers_info?: Array<{
        'one-time-leads'?: {
            value?: number
            type?: string
            expiryDate?: string
        }
        'recurring-leads'?: {
            value?: number
            type?: string
            promo_length?: number
        }
        'subscription-discount'?: {
            value?: number
            type?: string
            promo_length?: number
        }
        'subscription-discount-fixed-date'?: {
            value?: number
            type?: string
            endDate?: string
        }
    }> | null
    promo_expiry_date?: string | null
    user?: {
        user_id: number
        username: string
        first_name: string | null
        last_name: string | null
    } | null
}
